import React from 'react';
import { AppstoreOutlined, PartitionOutlined, CrownOutlined,
    BarChartOutlined, ClockCircleOutlined, HomeOutlined } from '@ant-design/icons';
import { Layout, Space, Row, Col } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { PageLinkCard } from '../../components/pageLinkCard/PageLinkCard';
import { Routes } from '../../routes';
import { authService } from '../../auth/authService';
import { Section } from '../../components/section/Section';
import { useFeatureFlags } from '../../featureFlags';
import { flags } from '../../featureFlags/flags';
import './styles.less';

// NOTE: These cards mirror the top-level groups of the nav menu in AppView.js and link
// to the same "middleman" landing pages. See the shared-nav-config TODO at the top of
// AppView.js — menu, landing pages and these cards should eventually share one config.
const HomeView = () => {
    const [ showObjectives, showLeaderboards, showBadges, showCertificates, showNotifications, showPageSetup ] =
        useFeatureFlags( [ flags.OBJECTIVES, flags.LEADERBOARDS, flags.BADGES, flags.CERTIFICATES, flags.NOTIFICATIONS, flags.PAGE_SETUP ] );

    const showIncentives = showObjectives || showLeaderboards || showBadges || showCertificates;

    return (
        <Layout className="home-page">
            <PageHeader
                className="home-header"
                title="Course Studio"
            />

            <Section className="home-page-body">
                <Space direction="vertical" size={ 16 }>
                    <Row gutter={ [ 16, 16 ] }>

                        { /* Learning Content */ }
                        <Col xs={ 24 } sm={ 12 } md={ 8 }>
                            <PageLinkCard
                                href={ Routes.LearningContentNav.buildPath() }
                                icon={ <AppstoreOutlined />  }
                                title="Learning Content"
                                description="Objects, courses, curricula, resources and instructor led training."
                            />
                        </Col>

                        { /* Content Taxonomy */ }
                        <Col xs={ 24 } sm={ 12 } md={ 8 }>
                            <PageLinkCard
                                href={ Routes.ContentTaxonomyNav.buildPath() }
                                icon={ <PartitionOutlined />  }
                                title="Content Taxonomy"
                                description="Organize content with categories and tags."
                            />
                        </Col>

                        { /* Incentives */ }
                        <Col xs={ 24 } sm={ 12 } md={ 8 }>
                            <PageLinkCard
                                disabled={ !showIncentives }
                                href={ Routes.GamificationNav.buildPath() }
                                icon={ <CrownOutlined />  }
                                title="Incentives"
                                description="Gamify user interactions with objectives, leaderboards, badges and certificates."
                            />
                        </Col>

                        { /* Notifications */ }
                        <Col xs={ 24 } sm={ 12 } md={ 8 }>
                            <PageLinkCard
                                disabled={ !showNotifications }
                                href={ Routes.NotificationsPage.buildPath() }
                                icon={ <ClockCircleOutlined />  }
                                title="Notifications"
                                description="Add, remove or edit notifications."
                            />
                        </Col>

                        { /* Homepage Setup */ }
                        <Col xs={ 24 } sm={ 12 } md={ 8 }>
                            <PageLinkCard
                                disabled={ !showPageSetup }
                                href={ Routes.ComponentsList.buildPath() }
                                icon={ <HomeOutlined />  }
                                title={ authService.isHoya() ? 'My Journey Setup' : 'Homepage Setup' }
                                description="Edit home page features."
                            />
                        </Col>

                        { /* Analytics */ }
                        <Col xs={ 24 } sm={ 12 } md={ 8 }>
                            <PageLinkCard
                                href={ Routes.Reporting.buildPath() }
                                icon={ <BarChartOutlined />  }
                                title="Analytics"
                                description="Reports, stats, data exports and warehouse imports."
                            />
                        </Col>
                    </Row>
                </Space>
            </Section>
        </Layout>
    );
};

export default HomeView;
